import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import {
  dataRequestLoading,
  dataRequestFailure,
  dataRequestCompleted,
  DATA_REQUEST_BEGIN,
} from '../shared/higherOrderReducers/withDataRequest/actionTypeFormatters';

import { LISTINGS_REDUCER_NAME } from './reducer';
import {
  getDealerListings,
  cacheDealerListings,
  applyCachedDealerListings,
  clearListingsCache,
} from './actions';
import {
  SET_FILTERS,
  CLEAR_DEALER_FILTERS,
  GET_DEALER_LISTINGS_SUCCESS,
  DEALER_LISTING_TOGGLE_REQUEST,
} from './constants';
import {
  getListingsFiltersReducer,
  selectDealerListings,
  getListingsCacheKey,
  selectDealerListingsCount,
  selectListingsCacheValue,
} from './selectors';
import { watchStartClearCacheTask } from './sagas.bg';

export function* handleGetDealerListingsSuccess() {
  const currentFilters = yield select(getListingsFiltersReducer);
  const currentListings = yield select(selectDealerListings);
  const currentTotal = yield select(selectDealerListingsCount);
  yield put(
    cacheDealerListings({
      [getListingsCacheKey(currentFilters)]: {
        dealerListings: currentListings,
        dealerListingsCount: currentTotal,
      },
    }),
  );
}

export function* handleListingsFiltersChangeAsync() {
  const cachedListings = yield select(selectListingsCacheValue);

  if (cachedListings) {
    yield put(applyCachedDealerListings(cachedListings));
  } else {
    yield put(getDealerListings());
  }
}

export function* handleClearListingsCache() {
  yield put(clearListingsCache());
}

// initial data request on mount
// cannot do this via router action because of ssr
export function* getListingsDataRequestAsync() {
  // clear cache to account for potential updates to listings
  yield put(clearListingsCache());

  yield put(dataRequestLoading(LISTINGS_REDUCER_NAME));
  try {
    yield put(getDealerListings());
  } catch (error) {
    yield put(dataRequestFailure(LISTINGS_REDUCER_NAME));
  } finally {
    yield put(dataRequestCompleted(LISTINGS_REDUCER_NAME));
  }
}

// watchers
export function* watchUpdateListingState() {
  yield takeLatest(DEALER_LISTING_TOGGLE_REQUEST, handleClearListingsCache);
}

export function* watchGetListingsSuccess() {
  yield takeLatest(GET_DEALER_LISTINGS_SUCCESS, handleGetDealerListingsSuccess);
}

export function* watchListingsFilterChange() {
  yield takeLatest(
    [SET_FILTERS, CLEAR_DEALER_FILTERS],
    handleListingsFiltersChangeAsync,
  );
}

export function* watchGetListingsDataRequestBegin() {
  yield takeLatest(
    DATA_REQUEST_BEGIN(LISTINGS_REDUCER_NAME),
    getListingsDataRequestAsync,
  );
}

export function* listingsSagas() {
  yield all([
    call(watchGetListingsDataRequestBegin),
    call(watchListingsFilterChange),
    call(watchGetListingsSuccess),
    call(watchUpdateListingState),
    // starts background task for clearing cache after specified duration
    call(watchStartClearCacheTask),
  ]);
}
